enum LoadingState {
  loading = "loading",
  success = "success",
  error = "error",
}

enum CrudStatus {
  none = "none",
  success = "success",
  error = "error",
  custom = "custom"
}

export {
  LoadingState,
    CrudStatus
}
